module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cLsLB"))).then(() => parcelRequire('ljYL6'));